import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a9ee52c2&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./detail.vue?vue&type=style&index=1&id=a9ee52c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ee52c2",
  null
  
)

export default component.exports